module.exports = __webpack_public_path__ + "fonts/font-icon-Enerdata.e0dc593.woff";